/*
  Market-aware money formatting.

  Several places in this theme formatted prices with a hardcoded 'nb-NO' locale
  and 'NOK' currency. On kulkid.se and kulkid.dk that renders SEK and DKK
  amounts with a Norwegian currency label, so the JS-rendered price disagreed
  with the Liquid-rendered price on the same page.

  window.KK.market is written by layout/theme.liquid from the active market.
  It also carries a sample amount run through Liquid's own money filter, and
  this file copies that pattern, so a price drawn by JS looks exactly like one
  drawn by Liquid: "4.299,00 kr" on NO, "3 199,00 kr" on SE, "1.099,00 kr" on
  DK. Intl is only the fallback: it disagrees with Shopify on separators and
  decimals, and adds a "kr." suffix in Danish.

  Note on shop.money_format: it returns the SHOP's format, not the active
  market's, so it is not safe to hand to Shopify.formatMoney on a non-primary
  market.

  Usage:
    KK.formatMoney(429900)                              -> "4.299,00 kr" (on NO)
    KK.formatMoney(429900, { withCurrencyCode: true })  -> Liquid's money_with_currency pattern
*/

window.KK = window.KK || {};

(function () {
  var fallback = {
    country: 'NO',
    currency: 'NOK',
    locale: 'nb-NO',
    showCurrencyCode: false,
  };

  function market() {
    return window.KK.market || fallback;
  }

  function activeCurrency() {
    if (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) {
      return window.Shopify.currency.active;
    }
    return market().currency || fallback.currency;
  }

  function activeLocale() {
    return market().locale || document.documentElement.lang || fallback.locale;
  }

  /*
    The sample is 1234567.00 in the market's format, e.g. "1.234.567,00 kr".
    Whatever surrounds the number is kept as prefix and suffix, the character
    after the leading 1 is the thousands separator, and a separator followed
    by 00 means the format shows decimals.
  */
  var patternCache = {};

  function parsePattern(sample) {
    if (!sample) return null;
    if (patternCache[sample]) return patternCache[sample];

    var match = String(sample).match(/^([\s\S]*?)1(\D?)234\D?567(?:(\D)00)?([\s\S]*)$/);
    if (!match) return null;

    patternCache[sample] = {
      prefix: match[1],
      thousands: match[2],
      decimal: match[3] || '',
      decimals: match[3] ? 2 : 0,
      suffix: match[4],
    };
    return patternCache[sample];
  }

  function applyPattern(amount, pattern, fractionDigits) {
    var digits = typeof fractionDigits === 'number' ? fractionDigits : pattern.decimals;
    var parts = Math.abs(amount).toFixed(digits).split('.');
    var whole = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, pattern.thousands);
    var number = parts[1] ? whole + (pattern.decimal || ',') + parts[1] : whole;
    return (amount < 0 ? '-' : '') + pattern.prefix + number + pattern.suffix;
  }

  /*
    cents: integer in the market's minor units, as returned by /cart.js and the
    Ajax product endpoints.
  */
  window.KK.formatMoney = function (cents, options) {
    var opts = options || {};
    var amount = (Number(cents) || 0) / 100;
    var currency = opts.currency || activeCurrency();
    var locale = opts.locale || activeLocale();
    // Plain money unless a caller asks for the code. currency_code_enabled is
    // on in this store, yet the theme's Liquid prices print "kr", so following
    // the setting here made JS prices say "NOK" next to Liquid's "kr".
    var showCode = Boolean(opts.withCurrencyCode);

    // The Liquid sample only describes the market's own currency.
    if (currency === market().currency && !opts.locale) {
      var pattern = parsePattern(showCode ? market().moneyWithCurrencySample : market().moneySample);
      if (pattern) return applyPattern(amount, pattern, opts.fractionDigits);
    }

    var config = {
      style: 'currency',
      currency: currency,
      minimumFractionDigits: typeof opts.fractionDigits === 'number' ? opts.fractionDigits : 0,
      maximumFractionDigits: typeof opts.fractionDigits === 'number' ? opts.fractionDigits : 0,
    };

    if (showCode) {
      config.currencyDisplay = 'code';
    }

    try {
      return new Intl.NumberFormat(locale, config).format(amount);
    } catch (error) {
      // Unknown locale or currency: fall back to a plain number plus the code.
      return amount.toFixed(config.maximumFractionDigits) + ' ' + currency;
    }
  };

  window.KK.currency = activeCurrency;
  window.KK.locale = activeLocale;
})();
